import { useState } from "react";
import { View, Text, TouchableOpacity, Image, StyleSheet } from "react-native";
import googleIcon from "../../../assets/googleIcon.png";
import Colors from "../../../Resources/Color";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";
import { useDevice } from "../../_layout";

/**
 * AccessWithGoogle Component
 * A reusable button component for Google authentication
 *
 * @param {string} mode - The mode of the button: "signin" or "signup"
 * @param {string} language - The language code: "en" or "es"
 * @param {function} onPress - The function to call when the button is pressed
 * @param {number} width - The width of the button (default: 232)
 * @param {boolean} isLoading - Whether the button is in a loading state
 * @param {function} setIsLoading - Function to set the loading state
 */
const AccessWithGoogle = ({
  mode = "signin",
  language = "en",
  onPress,
  width = 232,
  isLoading = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { isMobile } = useDevice();
  // Text mapping based on mode and language
  const textMap = {
    signin: {
      en: "Sign in with Google",
      es: "Acceder con Google",
    },
    signup: {
      en: "Sign up with Google",
      es: "Registrarse con Google",
    },
  };

  const buttonText = textMap[mode]?.[language] || textMap.signin.en;

  return (
    <TouchableOpacity
      onPress={onPress}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={[
        styles.button,
        {
          width: width,
          opacity: isHovered ? 0.8 : 1,
        },
      ]}
      activeOpacity={0.8}
      //   disabled={isLoading}
    >
      <View style={styles.content}>
        <Image source={googleIcon} style={styles.icon} resizeMode="contain" />
        <Text style={[styles.text]}>{buttonText}</Text>
      </View>
      {isLoading && (
        <View style={styles.loadingContainer}>
          <CustomActivityIndicator large={false} white={true} />
        </View>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    height: 44,
    backgroundColor: "#131314",
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#8E918F",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    borderRadius: 14,
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    width: 32,
    height: 32,
    marginLeft: -4,
  },
  text: {
    // fontFamily: "Roboto_500Medium",
    fontSize: 14,
    lineHeight: 20,
    fontWeight: "500",
    color: "#E3E3E3",
    marginLeft: 4,
  },
  loadingContainer: {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: [{ translateY: -9 }],
  },
});

export default AccessWithGoogle;
